import css from './graph.module.scss';

import { memo } from 'react';

import { TRect } from './type';

const Frame = ({
  graphRect,
  mode,
}: {
  graphRect: TRect;
  mode: 'background' | 'border';
}) => {
  const { bottom, left, right, top } = graphRect;

  return (
    <g data-role={`frame-${mode}`}>
      <polyline
        className={css.frame}
        data-mode={mode}
        points={[
          `${left},${top}`,
          `${right},${top}`,
          `${right},${bottom}`,
          `${left},${bottom}`,
          `${left},${top}`,
        ].join(' ')}
      />
    </g>
  );
};

export default memo(Frame);
